(function () {
  'use strict';

  // ── Constants ────────────────────────────────────────────────────────────
  var MAX_DIST = Math.sqrt(200 * 200 + 200 * 200);
  var CARD_ACCENT = {
    tl: 'rgba(229, 136, 37, 0.6)',
    tr: 'rgba(221, 74, 19, 0.6)',
    bl: 'rgba(110, 69, 35, 0.7)',
    br: 'rgba(140, 82, 255, 0.6)'
  };

  // ── State ────────────────────────────────────────────────────────────────
  var products = [];
  var puckX = 0, puckY = 0;
  var isDragging = false;
  var hasInteracted = false;
  var activeFilter = 'all';
  var resultsCount = 4;

  // ── DOM refs (set in init) ───────────────────────────────────────────────
  var compassEl, puckEl, resultsEl, quadrantEls;

  // ── Data loading ─────────────────────────────────────────────────────────
  function loadData() {
    var raw = document.getElementById('vibe-product-data');
    if (!raw) return;
    try {
      var parsed = JSON.parse(raw.textContent);
      products = parsed.map(function (p) {
        return {
          name: p.name,
          handle: p.handle,
          quadrant_x: Number(p.quadrant_x),
          quadrant_y: Number(p.quadrant_y),
          tasting_notes: p.tasting_notes || '',
          preparations: p.preparations || '',
          is_decaf: !!p.is_decaf
        };
      });
    } catch (e) {
      console.error('[torque-vibe] product data parse failed', e);
      products = [];
    }
  }

  // ── Compass engine ───────────────────────────────────────────────────────
  function getQuadrant(x, y) {
    if (x >= 0 && y >= 0) return 'tr';
    if (x < 0 && y >= 0) return 'tl';
    if (x < 0 && y < 0) return 'bl';
    return 'br';
  }

  function updateQuadrantColors(q) {
    ['tl', 'tr', 'bl', 'br'].forEach(function (key) {
      var el = quadrantEls[key];
      if (el) el.classList.toggle('active', key === q);
    });
  }

  function renderPuck() {
    puckEl.style.left = ((puckX + 100) / 2) + '%';
    puckEl.style.top = ((100 - puckY) / 2) + '%';
    if (!hasInteracted) return;
    var q = getQuadrant(puckX, puckY);
    updateQuadrantColors(q);
    document.documentElement.style.setProperty('--card-accent', CARD_ACCENT[q]);
    document.querySelectorAll('.torque-vibe-fp').forEach(function (el) {
      el.classList.remove('active');
    });
    var activeFp = document.querySelector('.torque-vibe-fp.' + q);
    if (activeFp) activeFp.classList.add('active');
  }

  function getEventCoords(e) {
    var t = e.touches ? e.touches[0] : e;
    return { clientX: t.clientX, clientY: t.clientY };
  }

  function updatePuckFromEvent(e) {
    var rect = compassEl.getBoundingClientRect();
    var coords = getEventCoords(e);
    var cx = rect.left + rect.width / 2;
    var cy = rect.top + rect.height / 2;
    var dx = coords.clientX - cx;
    var dy = coords.clientY - cy;
    var radius = rect.width / 2;
    var puckRadius = 32.5;
    var maxRadius = radius - puckRadius;
    var dist = Math.sqrt(dx * dx + dy * dy);
    var scale = dist > maxRadius ? maxRadius / dist : 1;
    puckX = Math.round((dx * scale / radius) * 100);
    puckY = Math.round(-(dy * scale / radius) * 100);
  }

  function snapToQuadrant(x, y) {
    puckEl.classList.add('snapping');
    puckEl.classList.remove('dragging');
    puckX = x;
    puckY = y;
    activate();
    renderPuck();
    renderResults(findMatches());
    setTimeout(function () { puckEl.classList.remove('snapping'); }, 350);
  }

  function activate() {
    if (hasInteracted) return;
    hasInteracted = true;
  }

  // ── Filter logic ─────────────────────────────────────────────────────────
  function prepMatches(prep, kind) {
    if (!prep) return false;
    var lower = String(prep).toLowerCase();
    if (kind === 'espresso') return lower.indexOf('espresso') !== -1;
    if (kind === 'filter') return lower.indexOf('filter') !== -1;
    return false;
  }

  function getFilteredProducts() {
    if (activeFilter === 'all')      return products.filter(function (p) { return !p.is_decaf; });
    if (activeFilter === 'decaf')    return products.filter(function (p) { return p.is_decaf; });
    if (activeFilter === 'espresso') return products.filter(function (p) { return !p.is_decaf && prepMatches(p.preparations, 'espresso'); });
    if (activeFilter === 'filter')   return products.filter(function (p) { return !p.is_decaf && prepMatches(p.preparations, 'filter'); });
    return products;
  }

  // ── Matching ─────────────────────────────────────────────────────────────
  function findMatches() {
    var pool = getFilteredProducts();
    return pool
      .map(function (c) {
        var dist = Math.sqrt(Math.pow(puckX - c.quadrant_x, 2) + Math.pow(puckY - c.quadrant_y, 2));
        var match = Math.round(100 - (dist / MAX_DIST * 100));
        return { handle: c.handle, name: c.name, dist: dist, match: match };
      })
      .sort(function (a, b) { return a.dist - b.dist; })
      .slice(0, resultsCount);
  }

  // ── Results render ───────────────────────────────────────────────────────
  function renderResults(matches) {
    if (!hasInteracted) return;
    resultsEl.style.display = '';

    var allCards = document.querySelectorAll('.torque-vibe-card-wrap');
    allCards.forEach(function (el) {
      el.style.display = 'none';
      el.style.order = '';
      var badge = el.querySelector('.torque-vibe-match-badge');
      if (badge) badge.textContent = '';
    });

    matches.forEach(function (m, i) {
      var card = document.querySelector('.torque-vibe-card-wrap[data-handle="' + m.handle + '"]');
      if (!card) return;
      card.style.display = '';
      card.style.order = String(i);
      var badge = card.querySelector('.torque-vibe-match-badge');
      if (badge) badge.textContent = m.match + '% match';
    });
  }

  // ── Filter pills ─────────────────────────────────────────────────────────
  function initFilters() {
    var pills = document.querySelectorAll('.torque-vibe-pill');
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var filter = pill.getAttribute('data-filter');
        if (!filter || filter === activeFilter) return;
        activeFilter = filter;
        pills.forEach(function (p) { p.classList.toggle('active', p === pill); });
        if (hasInteracted) renderResults(findMatches());
      });
    });
  }

  // ── Drag handlers ────────────────────────────────────────────────────────
  function startDrag(e, isTouch) {
    isDragging = true;
    puckEl.classList.add('dragging');
    puckEl.classList.remove('snapping');
    if (isTouch) e.preventDefault();
    updatePuckFromEvent(e);
    activate();
    renderPuck();
    renderResults(findMatches());
  }

  function moveDrag(e, isTouch) {
    if (!isDragging) return;
    if (isTouch) e.preventDefault();
    updatePuckFromEvent(e);
    renderPuck();
    renderResults(findMatches());
  }

  function endDrag() {
    if (!isDragging) return;
    isDragging = false;
    puckEl.classList.remove('dragging');
  }

  function initDrag() {
    compassEl.addEventListener('mousedown',  function (e) { startDrag(e, false); });
    compassEl.addEventListener('touchstart', function (e) { startDrag(e, true);  }, { passive: false });
    document.addEventListener('mousemove',  function (e) { moveDrag(e, false); });
    document.addEventListener('touchmove',  function (e) { moveDrag(e, true);  }, { passive: false });
    document.addEventListener('mouseup',    endDrag);
    document.addEventListener('touchend',   endDrag);
    document.addEventListener('touchcancel', endDrag);
  }

  function initQuadrantTaps() {
    document.querySelectorAll('.torque-vibe-fp').forEach(function (fp) {
      fp.addEventListener('click', function (e) {
        e.stopPropagation();
        var x = parseInt(fp.getAttribute('data-snap-x'), 10);
        var y = parseInt(fp.getAttribute('data-snap-y'), 10);
        if (!isNaN(x) && !isNaN(y)) snapToQuadrant(x, y);
      });
    });
  }

  // ── Init ─────────────────────────────────────────────────────────────────
  function init() {
    compassEl = document.getElementById('torque-compass');
    if (!compassEl) return;
    puckEl    = compassEl.querySelector('.torque-vibe-puck');
    resultsEl = document.getElementById('torque-vibe-results');
    quadrantEls = {
      tl: compassEl.querySelector('.torque-vibe-quadrant.q-tl'),
      tr: compassEl.querySelector('.torque-vibe-quadrant.q-tr'),
      bl: compassEl.querySelector('.torque-vibe-quadrant.q-bl'),
      br: compassEl.querySelector('.torque-vibe-quadrant.q-br')
    };

    var rc = parseInt(compassEl.getAttribute('data-results-count'), 10);
    if (!isNaN(rc) && rc > 0) resultsCount = rc;

    loadData();
    initFilters();
    initDrag();
    initQuadrantTaps();
    renderPuck();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();